var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgGroup8Gray51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 84.5,
    fill: "#F7FAFD",
    stroke: "#0074BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3485 75.6445C93.398 75.6445 92.5253 75.099 92.089 74.2575L90.967 71.998C90.2501 70.5799 88.3801 69.4111 86.7906 69.4111H83.222C81.617 69.4111 79.747 70.5799 79.0301 71.998L77.9081 74.2575C77.4718 75.099 76.5991 75.6445 75.6485 75.6445C72.267 75.6445 69.5866 78.4962 69.8048 81.8622L70.6151 94.734C70.8021 97.9442 72.5319 100.578 76.8329 100.578H93.1642C97.4652 100.578 99.1794 97.9442 99.382 94.734L100.192 81.8622C100.41 78.4962 97.7301 75.6445 94.3485 75.6445ZM82.661 77.5924H87.336C87.975 77.5924 88.5048 78.1222 88.5048 78.7611C88.5048 79.4 87.975 79.9299 87.336 79.9299H82.661C82.0221 79.9299 81.4923 79.4 81.4923 78.7611C81.4923 78.1222 82.0221 77.5924 82.661 77.5924ZM84.9985 94.5315C82.1 94.5315 79.7314 92.1784 79.7314 89.2643C79.7314 86.3502 82.0845 83.9971 84.9985 83.9971C87.9126 83.9971 90.2657 86.3502 90.2657 89.2643C90.2657 92.1784 87.897 94.5315 84.9985 94.5315Z",
    fill: "#0074BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGroup8Gray51);
export default __webpack_public_path__ + "static/media/img_group8_gray_51.4f16f96277d0d03cf7a8505590069ff5.svg";
export { ForwardRef as ReactComponent };